document.addEventListener("DOMContentLoaded", function () {
  const desc = document.querySelector('.category-description p');
  const richText = document.querySelector('.rich-text__container');
  if (!desc || !richText) return;

  // --- Clamp collection description to 2 lines and add read more ---
  // Always show read more button
  const readMoreLink = document.createElement('a');
  readMoreLink.href = '#';
  readMoreLink.textContent = 'Read more';
  readMoreLink.className = 'collection-read-more';

  readMoreLink.addEventListener('click', function(e) {
    e.preventDefault();
    // Remove clamp to show full description
    desc.style.display = '';
    desc.style.webkitLineClamp = '';
    desc.style.webkitBoxOrient = '';
    desc.style.overflow = '';
    richText.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  desc.insertAdjacentElement('afterend', readMoreLink);

  // --- Clamp rich text to 3 lines and add read more/read less toggle ---
  const regularText = richText.querySelector('.text-size--regular');
  if (regularText) {
    // Overlay element
    const overlay = document.createElement('div');
    overlay.className = 'rich-text-overlay';

    // Wrapper for positioning
    const wrapper = document.createElement('div');
    wrapper.className = 'rich-text-wrapper';

    // Move regularText into wrapper
    regularText.parentNode.insertBefore(wrapper, regularText);
    wrapper.appendChild(regularText);
    wrapper.appendChild(overlay);

    // Check if overflow
    const regularTextClamped = regularText.scrollHeight > 6 * parseFloat(getComputedStyle(regularText).lineHeight);
    if (regularTextClamped) {
      const richReadMore = document.createElement('a');
      richReadMore.href = '#';
      richReadMore.textContent = 'Read more';
      richReadMore.className = 'rich-text-read-more';

      let expanded = false;
      richReadMore.addEventListener('click', function(e) {
        e.preventDefault();
        expanded = !expanded;
        if (expanded) {
          wrapper.style.maxHeight = 'none';
          wrapper.style.overflow = 'unset';
          overlay.style.display = 'none';
          richReadMore.textContent = 'Read less';
          richReadMore.className = 'rich-text-read-less';
        } else {
          wrapper.style.maxHeight = '6em';
          wrapper.style.overflow = 'hidden';
          overlay.style.display = '';
          richReadMore.textContent = 'Read more';
          richReadMore.className = 'rich-text-read-more';
          // Add a little space before scrolling to richText
          const yOffset = -40; // 40px space above
          const y = richText.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });

      wrapper.insertAdjacentElement('afterend', richReadMore);
    } else {
      overlay.style.display = 'none';
    }
  }
});